import { Environment } from './model';

export const environment: Environment = {
  WEB_URL: 'https://stag.skiddo.my',
  API_URL: 'https://api.stag.skiddo.my/api',  
  GRAPHQL_URL: 'https://api.stag.skiddo.my/graphql',
  PRODUCTION: false,
};
